import { Link } from "react-router-dom";
import {
  ArrowRight,
  CalendarDays,
  MessageCircleHeart,
  Users,
} from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

export function HomePage() {
  const { t } = useTranslation();
  const steps = [
    { icon: Users, text: t("home.step1") },
    { icon: MessageCircleHeart, text: t("home.step2") },
    { icon: CalendarDays, text: t("home.step3") },
  ];
  return (
    <>
      <section className="hero-grid overflow-hidden px-5 py-20 sm:py-28">
        <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-[1.15fr_0.85fr] lg:items-center">
          <div>
            <p className="mb-5 text-sm font-bold uppercase tracking-[0.2em] text-primary">
              {t("home.eyebrow")}
            </p>
            <h1 className="max-w-3xl text-5xl font-bold leading-[1.02] tracking-[-0.04em] text-foreground sm:text-7xl">
              {t("home.title")}
            </h1>
            <p className="mt-7 max-w-2xl text-lg leading-8 text-muted-foreground">
              {t("home.body")}
            </p>
            <div className="mt-9 flex flex-col gap-3 sm:flex-row">
              <Button asChild size="lg">
                <Link to="/connect">
                  {t("home.connect")} <ArrowRight size={18} />
                </Link>
              </Button>
              <Button asChild size="lg" variant="outline">
                <Link to="/events">{t("home.events")}</Link>
              </Button>
            </div>
          </div>
          <div className="relative rounded-[2rem] bg-primary p-8 text-primary-foreground shadow-soft sm:p-11">
            <div className="absolute -right-10 -top-10 h-40 w-40 rounded-full bg-secondary/30" />
            <p className="relative text-sm font-bold uppercase tracking-widest text-primary-foreground/70">
              Mountain View
            </p>
            <p className="relative mt-6 text-3xl font-semibold leading-tight">
              Neighbors should know what help is available—and feel expected
              when they arrive.
            </p>
            <div className="relative mt-12 grid grid-cols-2 gap-3">
              <div className="rounded-2xl bg-white/10 p-5">
                <strong className="block text-3xl">2×</strong>
                <span className="text-sm text-white/70">
                  monthly distributions
                </span>
              </div>
              <div className="rounded-2xl bg-white/10 p-5">
                <strong className="block text-3xl">1</strong>
                <span className="text-sm text-white/70">
                  clear place to connect
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="bg-white px-5 py-20">
        <div className="mx-auto max-w-6xl">
          <h2 className="text-3xl font-bold tracking-tight">{t("home.how")}</h2>
          <div className="mt-10 grid gap-5 md:grid-cols-3">
            {steps.map(({ icon: Icon, text }, index) => (
              <div key={text} className="rounded-2xl border bg-background p-7">
                <div className="flex items-center justify-between">
                  <span className="grid h-11 w-11 place-items-center rounded-xl bg-secondary text-primary">
                    <Icon size={22} />
                  </span>
                  <span className="text-sm font-bold text-muted-foreground">
                    0{index + 1}
                  </span>
                </div>
                <p className="mt-8 text-lg font-semibold leading-7">{text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
